<div class="bot-page-main">
  <app-header-bot></app-header-bot>

  <div class="bot-container">
    <div style="text-align: center; margin-top: 15px; margin-bottom: 2px;">
      <h4
        style="margin: 0; color: #fcd535; font-size: 20px; text-transform: uppercase; letter-spacing: 1px; font-weight: 600;">
        CRED Hanuman Downside Bot
      </h4>
    </div>
    <div class="bot-container-top-row">

      <div class="bot-box-top-left">
        <app-adminBotDownSideRecentTrade></app-adminBotDownSideRecentTrade>
      </div>

      <div class="bot-box-chart">
        <div class="botChart">
          <app-chart *ngIf="chartStatus" class="trade_chart baseblock_wrapper" [chartData]="chartData"></app-chart>
        </div>
      </div>

      <div class="bot-box-top-right">
        <app-adminBotDownSideTopGainer></app-adminBotDownSideTopGainer>
      </div>

    </div>

    <div class="bot-history mt-3">
      <app-adminBotDownSideOrderHistory (botSelected)="onBotSelected($event)">
      </app-adminBotDownSideOrderHistory>
    </div>

  </div>
</div>